var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "193px",
    height: "176px",
    viewBox: "0 0 193 176",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C6107160-FC9D-4471-BC2C-D522C61A47F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 176 193 176 193 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "erorr",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "erorr-page",
    transform: "translate(-624.000000, -157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "face",
    transform: "translate(624.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.409074,136.23295 C122.65054,134.759955 123.271273,132.695215 123.271273,130.041119 L123.271273,119.557556 L106.777971,119.557556 L106.777971,130.041119 C106.777971,132.695215 107.449386,134.759955 108.792218,136.23295 C110.13505,137.705946 112.263201,138.442444 115.17667,138.442444 C118.09014,138.442444 120.167608,137.705946 121.409074,136.23295 L121.409074,136.23295 Z M101.229787,145.111223 C98.4934408,141.851862 97.1255344,137.19851 97.1255344,131.149047 L97.1255344,119.557556 L60,119.557556 L60,108 L133,108 L133,131.904633 C133,137.415112 131.555802,141.809178 128.667674,145.084977 C125.779279,148.362101 121.307708,150 115.252695,150 C108.640169,150 103.965867,148.369524 101.229787,145.111223 L101.229787,145.111223 Z",
    id: "Fill-3",
    fill: "#2B3E51"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6997245,26.3868066 L174.922865,26.3868066 L174.922865,17.6791604 L53.6997245,17.6791604 L53.6997245,26.3868066 Z M17.8112948,158.32084 L174.922865,158.32084 L174.922865,44.065967 L17.8112948,44.065967 L17.8112948,158.32084 Z M22.188354,17.472024 C24.6202603,17.472024 26.5917314,19.4288696 26.5917314,21.8427346 C26.5917314,24.2565997 24.6202603,26.2134453 22.188354,26.2134453 C19.7564477,26.2134453 17.7849766,24.2565997 17.7849766,21.8427346 C17.7849766,19.4288696 19.7564477,17.472024 22.188354,17.472024 L22.188354,17.472024 Z M40.265489,17.472024 C42.6973953,17.472024 44.6688664,19.4288696 44.6688664,21.8427346 C44.6688664,24.2565997 42.6973953,26.2134453 40.265489,26.2134453 C37.8335826,26.2134453 35.8621116,24.2565997 35.8621116,21.8427346 C35.8621116,19.4288696 37.8335826,17.472024 40.265489,17.472024 L40.265489,17.472024 Z M8.97529752,0 C4.04794904,0 0,3.83321139 0,8.72558921 L0,167.226651 C0,172.117445 4.04794904,176 8.97529752,176 L183.966483,176 C188.897288,176 193,172.117445 193,167.226651 L193,8.72558921 C193,3.83321139 188.897288,0 183.966483,0 L8.97529752,0 Z",
    id: "Fill-5",
    fill: "#53BBBB",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1-Copy",
    fill: "#2D4251",
    mask: "url(#mask-2)",
    points: "75 84.6000533 63.89992 73.494533 74.9978668 62.3938129 67.5954136 55 56.4966669 66.0993866 45.39952 55 38 62.3938129 49.0995467 73.4996 38 84.6000533 45.39952 92 56.4966669 80.90008 67.5994134 92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2-Copy",
    fill: "#2D4251",
    mask: "url(#mask-2)",
    points: "155 84.6000533 143.89992 73.494533 154.997867 62.3938129 147.595414 55 136.496667 66.0993866 125.39952 55 118 62.3938129 129.099547 73.4996 118 84.6000533 125.39952 92 136.496667 80.90008 147.599413 92"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerDown);
export default __webpack_public_path__ + "static/media/serverDown.fef645746f3ac61d39265c6b1c7501aa.svg";
export { ForwardRef as ReactComponent };